import TCPassengerUIModel from './tc-passenger';

class TCPassengersCollectionUIModel {
  constructor(passengers = []) {
    this.passengers = passengers.map(pax => {
      return new TCPassengerUIModel(pax);
    });
  }
}

export default TCPassengersCollectionUIModel;